module.exports = __webpack_public_path__ + "img/feedback.6d53ec37.png";